<template>
    <div class="ProgrammerDay">
      <img
        class="ProgrammerDay_img"
        src='https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-14-27cnqkWUHPkRH2s0b.png'
        style="marginBottom: 16px"
      />
      <div class="ProgrammerDay_tips">
        <span @click="() => openUrl('http://sd.jd.com/article/38211?isHideShareButton=1')">
          点击查看抽奖攻略
        </span>
      </div>
      <div class="ProgrammerDay_container" style="marginBottom: 24px">
        <img
          src='https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-15-00AdLv0AAptzD7Ko3.png'
          class="ProgrammerDay_img"
        />
          <img
            :src="activitySecondStatus > 0 ? 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-18-05QXsaoKKjfvv5c20F.png' : 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-18-05vtQnhGbMXl0Eekg.png'"
            class="ProgrammerDay_punch1"
            @click="() => {
              openActivityUrl(2)
            }"
          />
          <img
            :src="
              activityThirdStatus > 0
                ? 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-18-03vLjIY9DtLRI8rNA.png'
                : 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-18-04eBNyJOcnBEpn00v.png'
            "
            class="ProgrammerDay_punch2"
            @click="() => {
              openActivityUrl(0)
            }"
          />
          <img
            :src="
              activityFirstStatus > 0
                ? 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-10-10-19mGpg0UG46XXIF8a6.png'
                : 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-10-10-20r10k6910IJZ8QycuD.png'
            "
            class="ProgrammerDay_punch3"
            @click="() => {
              openActivityUrl(1)
            }"
          />
          <img
            class="ProgrammerDay_punch_box"
            :src=" (activityFirstStatus > 0 || activitySecondStatus > 0 || activityThirdStatus > 0) && canDraw ? 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-15-07FIfeago38uXf9thU.png' : 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-10-14-11-36OHR0wDsaZQY24FC6.png'"
            @click="openPrizeDrawDialog"
          />
      </div>
      <img
        src='https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-15-52qNHPjNuWPr52aTqM.png'
        class="ProgrammerDay_img"
      />
      <div class="ProgrammerDay_events">
        <div
        class="ProgrammerDay_events_item"
              v-for="(item, index) in eventList"
              :key="index"
              @click="() => {
                openUrl(item.url);
              }"
            >
            <img
              :src="
                item.image ||
                'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-10-14-11-27uw52Jis10FuD8OQDI.png'
              "
            />
            </div>
      </div>
      <div class="ProgrammerDay_prices">
            <img
              class="ProgrammerDay_prices_item"
              v-for="(item, index) in priceList"
              :key="index"
              :src="
                item.image ||
                'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-10-14-11-27uw52Jis10FuD8OQDI.png'
              "
              @click="() => {
                openUrl(item.url);
              }"
            />
      </div>
      <img
        src='https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-16-534EaH10hhFPZQG0Fj.png'
        class="ProgrammerDay_img"
      />
      <!-- 抽奖弹窗 -->
      <div v-if="visible" class="ProgrammerDay_prize_dialog">
        <div>
          <img
            v-if="dialogStatus === STATUS_1024.drawing"
            src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2024-10-08-15-07FIfeago38uXf9thU.png"
            class="ProgrammerDay_drawing animate__animated animate__pulse"
          />
          <img
            v-if="dialogStatus === STATUS_1024.losing_lottery"
            :src="isPr ? (is1024 ? './../../assets/1024/isPr_is1024_lost.png' : './../../assets/1024/isPr_not1024_lost.png') : './../../assets/1024/notPr_lost.png'"
          />
          <img
            v-if="dialogStatus === STATUS_1024.price && prizeInfo"
            :src="prizeInfo.rewardImg"
            class="dissatisfy_prize_icon"
          />
          <div
            v-if="dialogStatus !== STATUS_1024.drawing"
            class="ProgrammerDay_dialog_footer"
          >
            <img
              v-if="isPr && is1024"
              src="./../../assets/1024/1024_gift.png"
              class="ProgrammerDay_dialog_footer_gift"
            />
            <img
              v-if="isPr"
              :src="is1024 ? './../../assets/1024/ispr_is1024_text.png' : './../../assets/1024/ispr_not1024_text.png'"
              class="ProgrammerDay_dialog_footer_text"
            />
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import api from '@/api';
import { mapState } from 'vuex'
import moment from 'moment';

export default {
  data() {
    return {
      priceList: [],
      eventList: [],
      lottery: false,
      activityList: [],
      prizeInfo: null,
      activityFirstStatus: 0,
      activitySecondStatus: 0,
      activityThirdStatus: 0,
      isLoading: false,
      visible: false,
      dialogStatus: null,
      isPr: 0,
      is1024: 0,
      canDraw: moment().isAfter(moment('2024-10-24 10:24:00')),
      STATUS_1024: {
        rules: 'rules', // 规则
        drawing: 'drawing', // 开奖中
        dissatisfy_condition: 'dissatisfy_condition', // 不满足条件
        losing_lottery: 'losing_lottery', // 未中奖
        prize: 'prize', // 已中奖，展示奖品
        start_draw: 'start_draw', // 开始抽奖
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  mounted() {
    this.getLotteryInfo();
    this.getActivityList();
  },
  methods: {
    async getActivityList() {
      const { data, code } = await api.fetchActivityList();
      if (+code === 200) {
        this.priceList = data?.slice(6) || [];
        this.eventList = data?.slice(3, 6) || [];
        this.activityList = data?.slice(0, 3) || [];
      }
    },
    async getLotteryInfo() {
      try {
        const { data, code } = await api.getLottery();
        if (+code === 200) {
          this.lottery = data?.lottery || false;
          this.activityFirstStatus = data?.activityFirst || 0;
          this.activitySecondStatus = data?.activitySecond || 0;
          this.activityThirdStatus = data?.activityThird || 0;
          this.is1024 = data?.is1024 || 0;
          this.isPr = data?.isPr || 0;
        }
      } catch (e) {
        this.activityFirstStatus = 0;
        this.activitySecondStatus = 0;
        this.activityThirdStatus = 0;
        this.is1024 = 0;
        this.isPr = 0;
      }
    },
    openUrl(url) {
      if (!url) return;
      window.jme.browser.openUrl({
          url
      });
    },
    openActivityUrl(index) {
      if (this.activityList && this.activityList[index]?.url) {
        this.openUrl(this.activityList[index]?.url)
      }
    },
    async drawPrize() {
      try {
        if (this.dialogStatus === this.STATUS_1024.drawing) return;
      this.dialogStatus = this.STATUS_1024.drawing;
      const { code, data } = await api.postLottery();
      if (+code === 200) {
        if (+data === 1) {
          this.visible = false;
          this.$toast.fail('还未到开奖时间');
          return;
        }
        if (+data === 2) {
          // 抽奖结束
          const assignment = await this.getPrizeList();
          if (assignment?.completionFlag) {
            // 已自动抽奖
            this.getPrize();
            return;
          } else {
            // 未自动抽奖，继续等待
            this.dialogStatus = this.STATUS_1024.drawing;
            this.visible = true;
          }
        }
      } else {
        this.visible = false;
        this.dialogStatus = this.STATUS_1024.rules;
      }
      } catch(e) {
        this.visible = false;
        this.dialogStatus = this.STATUS_1024.rules;
      }

    },
    openPrizeDrawDialog(e) {
      e.stopPropagation();
      if (!this.canDraw || (this.activityFirstStatus < 1 && this.activitySecondStatus < 1 && this.activityThirdStatus < 1)) {
        this.openUrl('http://sd.jd.com/article/38211?isHideShareButton=1');
        return;
      }
      this.$toast('请前往PC端抽奖～')
      // if (!(this.activityFirstStatus > 0 || this.activitySecondStatus > 0 || this.activityThirdStatus > 0)) {
      //   this.openActivityRuleUrl();
      //   return;
      // }
      // if (moment().isBefore(moment('2024-10-25 10:24:00'))) {
      //   this.openActivityRuleUrl();
      //   return;
      // }
      // if (!this.lottery) {
      //    // 可以抽奖
      //   this.drawPrize();
      //   this.visible = true;
      //   return;
      // } else {
      //   if (this.isLoading) return;
      //   this.isLoading = true;
      //   this.getPrize();
      // }
    },
    async getPrizeList() {
     try {
       const { data } = await api.fetchPrizeList(this.userInfo.erp);
       const { code, subCode, assignmentList } = data;
      if (code !== '0' || subCode !== '0') {
        return this.$toast.fail('获取中奖结果失败，请稍后重试');
      }
      const assignment = assignmentList?.find(
        (item) => item.encryptAssignmentId === '4Q32GL1fRjQxtjZfJboch8K5CRYz',
      );
      return assignment;
     } catch(e) {
      console.log(e)
      return null
     }
    },
    async getPrize() {
      try {
        const assignment = await this.getPrizeList();
        const { data } = await api.fetchPrize(this.userInfo.erp);
        const { code, subCode, assignmentRewards } = data;
        this.isLoading = false;
        if (code !== '0' || subCode !== '0') {
          return this.$toast.fail('获取中奖结果失败，请稍后重试');
        }
        if (
          !assignmentRewards ||
          !assignmentRewards['4Q32GL1fRjQxtjZfJboch8K5CRYz'] ||
          !assignmentRewards['4Q32GL1fRjQxtjZfJboch8K5CRYz'][5]?.length
        ) {
          // 未中奖
          this.dialogStatus = this.dialogStatus.losing_lottery;
          this.visible = true;
          this.lottery = true;
          return;
        }
        const reward = assignmentRewards['4Q32GL1fRjQxtjZfJboch8K5CRYz'][5][0];
        const rewardInfo = assignment?.rewards?.find(
          (item) => +item.rewardValue === +reward.rewardValue,
        );
        this.prizeInfo = rewardInfo;
        this.dialogStatus = this.STATUS_1024.prize;
        this.lottery = true;
        this.visible = true;
      } catch (e) {
        this.isLoading = false;
      }
    }
    },
  }
</script>
<style lang="less" scoped>
.ProgrammerDay {
  min-height: calc(100vh - 24px);
  // padding-top: 45vw;
  padding: 96px 24px 24px;
  // background: linear-gradient(to bottom, #F6484C, #F4D18D);
  background-image: url('./../../assets/bg_1024.png');
  background-size: 100% 100%;
}
.ProgrammerDay_img {
  width: 100%;
}
.ProgrammerDay_container {
  // background: linear-gradient(to bottom, #e7594b, #F4D18D);
  position: relative;
}
.ProgrammerDay_punch1 {
  position: absolute;
  right: 2%;
  bottom: 10%;
  z-index: 3;
  width: 30%;
}
.ProgrammerDay_punch2 {
  position: absolute;
  top: 35%;
  left: -2%;
  z-index: 3;
  width: 28%;
}
.ProgrammerDay_punch3 {
  position: absolute;
  top: -2%;
  right: 10%;
  z-index: 3;
  width: 28%;
}
.ProgrammerDay_punch_box {
  position: absolute;
  top: 17%;
  left: 29%;
  z-index: 1;
  width: 30%;
  // height: 20vw;
  cursor: pointer;
  animation-iteration-count: infinite;
  // transform: translate(-50%, -50%);
}
.ProgrammerDay_punch_hover_box {
  &:hover {
    width: calc(30% + 4px);
  }
}
.ProgrammerDay_punch_open_box {
  position: absolute;
  top: 15%;
  left: 27%;
  width: 35%;
  // top: 5%;
  // left: 30%;
  // z-index: 1;
  // height: 25vw;
  cursor: pointer;
  &:hover {
    width: calc(35% + 4px);
  }
}
.ProgrammerDay_events {
  display: flex;
  // grid-row-gap: 16px;
  // // grid-column-gap: 16px;
  // grid-template-columns: 32% 34% 32%;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  padding-top: 16px;
}
.ProgrammerDay_prices {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 24px;
}
.ProgrammerDay_events_item {
  // display: flex;
  flex: 1;
  flex-shrink: 0;
  
  display: block;
  object-fit: contain;
  img {
    width: 100%;
  }
}
.ProgrammerDay_prices_item {
  width: 48%;
}
.ProgrammerDay_events_item_logo {
  // flex-shrink: 0;
  width: 100%;
  // width: 12vw;
  // height: 6.5vw;
  // margin-right: 16px;
  // border-radius: 12px;
}
.ProgrammerDay_events_item_container {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
}
.ProgrammerDay_events_item_info {
  & > div {
    img {
      height: 18px;
      margin-right: 8px;
    }
    font-weight: bold;
    font-size: 18px;
  }
  & > span {
    display: -webkit-box;
    overflow: hidden;
    font-size: 12px;
    text-overflow: ellipsis;
    word-break: break-word;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.ProgrammerDay_events_item_time {
  display: grid;
  font-weight: bold;
  font-size: 13px;
}
.ProgrammerDay_prize_dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
}
.ProgrammerDay_drawing {
  max-width: 50vw;
  max-height: 50vh;
  animation-iteration-count: infinite;
}
.ProgrammerDay_rules {
  max-width: 60vw;
  max-height: 60vh;
}
.dissatisfy_condition_icon {
  max-width: 50vw;
  max-height: 50vh;
}
.dissatisfy_prize_icon {
  max-width: 70vw;
  max-height: 70vh;
}
.ProgrammerDay_tips {
  text-align: center;
  & > span {
    color: #fff;
    font-weight: bold;
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;
  }
}

</style>